import * as React from 'react';
import { formatMoney } from '@shopify/theme-currency';
import '../../styles/components/price.scss';

export type MoneyFormat = string | '${{ amount }}';

interface PriceProps {
    productId: number;
    price: number;
    compareAtPrice: number;
    moneyFormat: MoneyFormat;
}
const Price = (props: PriceProps) => {
    const { price, compareAtPrice, moneyFormat, productId } = props;
    return (
        <div className={'price' + (compareAtPrice > 0 ? ' price--sale' : '')}>
            <span className="money" data-product-id={productId}>
                {formatMoney(price, moneyFormat).replace('.00', '')}
            </span>
            {compareAtPrice > 0 ? (
                <s>
                    {formatMoney(compareAtPrice, moneyFormat).replace(
                        '.00',
                        ''
                    )}
                </s>
            ) : (
                ''
            )}
        </div>
    );
};
export default Price;
